import CONFIG from '@/constants/config.js';
export const helper = {
    data(){
        return {

        }
    },
    computed:{
        isMobile(){
            return this.isIpadOrPhone();
        }
    },
    methods:{
        removeWhiteSpace(str){
            return str.replace(/\s/g, "");
        },

        dateIsGreatherThanTreeMonth(dateStr){
            console.log(dateStr);
            return false;
            /*
            let date=new Date(dateStr);
            return this.dateIsGreaterThanXMonth(date,3)
            */
        },

        getFormatedDate(dateStr,durationInMinutes){
            let date=new Date(dateStr);
            if(this.dateIsGreatherThanTreeMonth(dateStr,3)){
                return "Demnächst";
            }

            if(dateStr){
                let res=date.toLocaleString("de",{
                    weekday: "short",
                    year: "numeric",
                    month: "2-digit",
                    day: "numeric",
                    hour:"numeric",
                    minute:"numeric"
                });
                if(durationInMinutes){
                    date.setMinutes(date.getMinutes()+durationInMinutes);
                    res+=" - "+date.toLocaleString("de",{
                        hour:"numeric",
                        minute:"numeric"
                    });
                }

                return res;
            }

            return dateStr;
        },
        dateIsGreaterThanXMonth(date,month){
            if(date){
                let futureTimestamp = new Date().getTime() + (month*30 * 24 * 60 * 60 * 1000);
                return date.getTime()>futureTimestamp;
            }
            return false;
        },
        screenWidth(){
            return (window.innerWidth > 0) ? window.innerWidth : screen.width;
        },
        isIpadOrPhone(){
            return this.screenWidth()<800;
        },
        isSmallTouchDevice(){
            return this.screenWidth()<700;
            //return ("ontouchstart" in document.documentElement);
        },
        isMobileTouchDevice(){
			return  ("ontouchstart" in document.documentElement);
		},
        getArrayAsString(dataset,ids){
			let res=this.getAsStringArray(dataset,ids);
			if(this._.isArray(res)){
				res=this._.join(res," | ");
			}
			return res;
        },
        getAsStringArray(dataset,ids){
			let res="";
			if(this._.isArray(ids)){
				res=this._.filter(dataset,(c)=> { return this._.includes(ids, c.id) });
				res=this._.map(res, 'name');
			}
			return res;
        },
        compareIdWithIds(ids,id){
			let res=false;
			if(this._.isArray(ids)){
				res=this._.includes(ids, id);
			}
			return res;
        },
        getModifiedImage(img){
            if(this._.isString(img)){
                img=img.replace("https://drive.google.com/open", "https://drive.google.com/uc");
                if(img.startsWith('/')){
                    img=CONFIG.URL+img;
                }
            }else{
                img="";
            }
            return img;
        },
        filterEmptyData(data){
            return this._.filter(data,(d)=>{
                return (d!=""&&d!="0" && d!=null);
            });
        },
        scrollToTop () {
            //window.scrollTo(0, 0)
        },
        newUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        removeHtmlTags(str){
            if(this._.isString(str)){
                str=str.replace(/<[^>]*>?/gm, '');
            }
            return str;
        },
        getCoord(row){
            let res="";
            if(row){
                if(row.c_city!=null && row.c_city!="" && row.street!=null && row.street!=""){
                    let params=[row.street];//TODO unternehemn dazu?
                    if(row.plz!=null && row.plz!=""){
                        params.push(row.plz+" "+row.c_city);
                    }else{
                        params.push(row.c_city);
                    }
                    

                    let paramsString=params.join(' | ');

                    //res="<a href='https://www.google.com/maps/search/?api=1&"+encodeURIComponent(paramsString)+"' target='_blank'>";
                    //res+=paramsString;
                    //res+="</a>";

                    //TODO Link einbauen
                    res=paramsString;

                }
            }
            return res;
        },
        getContact(row){
            
            let res=[];
            if(row){
                //Email
              if(row.email!=null && row.email!=""){
                res.push(row.email);
              }
              //Tel
              if(row.tel!=null && row.tel!=""){
                res.push(row.tel);
                  //res.push("<a class='telnr' href='tel:"+row.tel+"'>"+row.tel+"</a>");
              }
            }
      
            return this._.isEmpty(res)?"":res.join(' | ');
          },
        getShopsWithAttrCount(catId,dataset,attr){
            if(null!=catId && dataset && attr){
                let res= this._.filter(dataset,(shop)=>{
                    return this.compareWithCategories(shop[attr],catId);
                });

                return res.length;
            }
            return 0;
        },
    }
}